module.exports = __webpack_public_path__ + "img/repair_card1.817e4030.png";